import {useMemo} from 'react';
import {IGetAIReviewJobDetailsResponse} from '../../../../../api/types/aiReview.type';
import {useGetProtocolVersionDetails} from '../../../../../hooks/ai/review/useReview';
import {
  JobDetailsArtifacts,
  resolveJobDetailsArtifacts,
} from './jobDetailsArtifacts';

export const useJobDetailsArtifacts = (
  jobDetails?: IGetAIReviewJobDetailsResponse | null
): {
  artifacts: JobDetailsArtifacts | null;
  isLoading: boolean;
} => {
  const versionId = jobDetails?.reviewProtocolVersionID ?? null;
  const {data: protocolVersion, isLoading} = useGetProtocolVersionDetails(
    versionId,
    Boolean(versionId)
  );

  const artifacts = useMemo(() => {
    if (versionId && isLoading && !protocolVersion) {
      return null;
    }

    return resolveJobDetailsArtifacts(jobDetails, protocolVersion);
  }, [jobDetails, protocolVersion, versionId, isLoading]);

  return {
    artifacts,
    isLoading: Boolean(versionId) && isLoading,
  };
};
